import { useComponentTranslation } from '@core/i18n'
import { Card, CardBody, Flex, Heading, Icon, Text } from '@core/ui-elements'
import { MdOutlineQrCodeScanner } from 'react-icons/md'

export const QRCodeCard = () => {
  const t = useComponentTranslation('SetIndentification')

  return (
    <Card
      backgroundColor="blue.100"
      borderRadius="0.5rem"
      colorScheme="blue"
      direction="row"
      overflow="hidden"
      variant="filled"
      width="100%"
    >
      <Flex
        alignItems="center"
        backgroundColor="blue.200"
        border="0.125rem solid transparent"
        borderRightColor="blue.500"
        justifyContent="center"
        padding="1rem"
      >
        <Icon as={MdOutlineQrCodeScanner} fontSize="3rem" />
      </Flex>

      <CardBody padding="1.5rem 1rem">
        <Heading fontSize="0.875rem">{t('Scan the QR Code')}</Heading>
        <Text fontSize="0.875rem">{t('It has your unique ID')}</Text>
      </CardBody>
    </Card>
  )
}
